<template>
  <div class="page_bg" style="margin:0;">
    <!-- 顶部搜索和banner -->
    <div class="index_search_banner ">

      <!-- <div class="index_serch_btn">
        <div class="serch_btn_items  ">
          <span v-for="(hot,hot_index) in hotList" :key="hot_index" class="btn_item"
                @click="$router.push('/product/searchpro?name=' + (hot.radio === 1 ? hot.search2 : hot.search1))"
          >{{ hot.radio === 1 ? hot.search2 : hot.search1 }}</span>
        </div>
      </div> -->
      <div class="index_search flex-r-sb-c">
        <i class="van-icon van-icon-search" style="margin-left: 0.37rem;color: #C2C2C2;font-size: 0.55rem;" />
        <div class="hot_swiper" @click="$router.push('/product/searchpro')">
          <van-swipe class="my-swipe" autoplay="3000" :show-indicators="false" vertical>
            <van-swipe-item v-for="(hot,hot_index) in hotList" :key="hot_index" class="flex-r-s-c">
              <span
                @click.stop="$router.push('/product/searchpro?name=' + (hot.radio === 1 ? hot.search2 : hot.search1))"
              >{{ hot.radio === 1 ? hot.search2 : hot.search1 }}</span>
              <van-image width="0.37rem" height="0.37rem"
                         src="https://hxxxkj-oss-cdn.xiaoyi120.com/sysx-xcx/index/ser_hot.png" fit="fill"
                         @click.stop="$router.push('/product/searchpro?name=' + (hot.radio === 1 ? hot.search2 : hot.search1))"
              />
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="ser_btn" @click="$router.push('/product/searchpro')">搜索</div>
      </div>
      <div class="index_bg_banner">
        <van-swipe class="my-swipe" :show-indicators="false">
          <van-swipe-item v-for="(banner,index_banner) in banners" :key="index_banner">
            <van-image width="10rem" height="7.09rem" :src="banner.imageUrl" fit="fill"
                       @click="jumpSale('banner',banner)"
            />
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <!-- 滚动通知 -->
    <div class="home_noticeBar flex-r-s-c">
      <div class="flex-c-c-c noticeBar_img">
        <van-image width="1.6rem" height="0.64rem"
                   src="https://hxxxkj-oss-cdn.xiaoyi120.com/wholesale-H5/home_noticeBar2.png"
        />
      </div>
      <div class="noticeBar_blank" />
      <van-notice-bar style="width:6.4rem;padding-left:0.1rem" :text="notice[0].name" mode="" color="#333"
                      background="#ffffff" @click="jumpSale('notice',notice[0])"
      />
    </div>
    <!-- 总代 -->
    <div class="index_agency flex-c-c-c">
      <van-image class="agency_icon" width="3.14rem" height="0.64rem" :src="require('../../assets/agency_icon.png')" />
      <div class="agency_more" @click="jumpAgency(null)">查看更多 <van-icon name="arrow" /> </div>
      <div class="agency_boxs flex-r-sa-s">
        <div class="agency_box flex-r-s-s">
          <van-swipe class="my-swipe " autoplay="false" style="border-radius: 0.21rem;" :show-indicators="false">
            <van-swipe-item v-for="(agency,index_agency) in agencyBrandList" :key="index_agency">
              <div class="flex-r-s-s" style="flex-wrap: wrap;">
                <div v-for="(item,index) in agency" :key="index" class="agency_box_item">
                  <van-image width="2.77rem" height="1.49rem" :src="item.logoUrl" @click="jumpAgency(item)" />
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="agency_video">
          <video id="myVideo" class="video_box" controls autoplay muted loop preload="auto" playsinline
                 webkit-playsinline
                 src="https://hxxxkj-oss-cdn.xiaoyi120.com/wholesale-H5/video/agency_video.mp4"
          />
        </div>
      </div>
    </div>
    <!-- 限时特惠 -->
    <div class="active_area2">
      <div class="area" style="padding-bottom:0.3rem">
        <div class="more" @click="jumpTagList">查看更多
          <van-icon name="arrow" />
        </div>
        <van-swipe class="my-swipe " autoplay="3000" style="border-radius: 0.21rem;" :show-indicators="true">
          <van-swipe-item v-for="(specil,index_specil) in specilActive" :key="index_specil">
            <div class="flex-r-s-s" style="flex-wrap: wrap;">
              <div v-for="(specil_item,specil_index2) in specil" :key="specil_index2" class="specil_box">
                <div class="specilpro_box" @click="jumpjianlou(specil_item)">
                  <van-image width="4.27rem" height="4.27rem" :src="specil_item.iconUrl" />
                  <div class="specilpro_box_name van-ellipsis">{{ specil_item.name }}</div>
                  <div class="specilpro_box_brand van-ellipsis">{{ specil_item.brand }} ||
                    {{ specil_item.specifications }}</div>
                  <div class="specilpro_box_priceCart flex-r-sb-c">
                    <div class="price"><span style="font-size: 0.29rem;">￥</span>{{ specil_item.price }}</div>
                    <van-icon name="cart" color="rgb(7, 103, 171)" size="0.4rem" style="margin-right:0.2rem"
                              @click.stop="toCart(specil_item)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <!-- 全部商品 -->
    <div class="active_area2 active_area3 " style="margin-bottom: 4rem;position: relative;">
      <div class="area area3" style="padding-bottom:0.3rem;">
        <!-- <div class="more" @click="toAllPro">查看更多
          <van-icon name="arrow" />
        </div> -->
        <div class="more" style="height: 0.5rem;">&nbsp;
        </div>
        <!-- 顶部过滤 -->
        <ser_top_filter_right ref="serTopFilter" :type="4" :name="searchValue"
                              style="padding-top: 0.05rem;border-radius: 0.27rem;" @changeFilter="changeFilter"
                              @changeFiltercategory="changeFiltercategory"
        />
        <div class="pro_list_box">
          <MyscrollList ref="myList01" :list="proList" :line-type="3" :is-btn="true" style="margin-top: -0.2rem;"
                        @myload="proload"
          >
            <template #default="slotProps">
              <div class="area3_list">
                <div class="flex-r-s-s" style="flex-wrap: wrap;">
                  <div class="pros_box_index">
                    <div class="specilpro_box" @click="jumpjianlou(slotProps.item)">
                      <van-image width="2.67rem" height="2.67rem" :src="slotProps.item.iconUrl" />
                      <div class="specilpro_box_name van-ellipsis">{{ slotProps.item.name }}</div>
                      <div class="specilpro_box_brand van-ellipsis">{{ slotProps.item.brand }} ||
                        {{ slotProps.item.specifications }}</div>
                      <div class="specilpro_box_priceCart flex-r-sb-c">
                        <div class="price"><span style="font-size: 0.29rem;">￥</span>{{ slotProps.item.price }}</div>
                        <van-icon name="cart" color="rgb(7, 103, 171)" size="0.4rem" style="margin-right:0.2rem"
                                  @click.stop="toCart(slotProps.item)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </MyscrollList>
        </div>

      </div>
    </div>
    <!-- 横幅模块展示 -->
    <!-- <div class="streamer_box" style="margin-top:0.21rem;padding-bottom:1.8rem">
      <van-image v-for="(streamer,streamer_index) in streamerList" :key="streamer_index" width="9.36rem"
                 height="height: 2.4rem;" :src="streamer.imageUrl" @click="jumpSale('streamer',streamer)"
      />
    </div> -->
    <!-- 底部留白 -->
    <div class="bottom_blank" />
    <!-- Tabber -->
    <!-- <Tabber ref="tabber" :list="tabberList" :index="1" :showcart="true" /> -->
    <Tabber ref="tabber" :index="1" />
    <!-- 资质认证弹窗 -->
    <van-dialog v-model="certificationShow" :show-confirm-button="false">
      <div class="certification_dialog flex-c-c-c">
        <van-image width="4.11rem" height="2.75rem"
                   src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/shop2.0/home/certification.png"
        />
        <div class="certification_title"> 您尚未提交认证资料 </div>
        <div class="certification_tip"> 暂时无法采购 </div>
        <van-button class="certification_btn" round type="info" color="#0767ab" @click="toUpCertification">立即认证
        </van-button>
      </div>
    </van-dialog>
    <!-- 广告营销 -->
    <van-dialog v-model="adsDialog" :show-confirm-button="false" style="width:7.09rem;background:none">
      <div v-if="adsDialog" class="adsDialog_box flex-c-c-c">
        <van-icon class="adsDialog_box_close" name="close" @click="Closeadvs" />
        <van-image class="vipGetDialog_btn" width="100%" height="100%" :src="adsItem[0].imageUrl"
                   @click="jumpSale('advs',adsItem[0])"
        />
      </div>
    </van-dialog>
    <!-- 客服组件 -->
    <kefuBtn ref="mykefuBtn" />
    <div class="kefu_popup" @click="openKeFu">
      <van-image width="1.87rem" height="1.87rem" :src="require('../../assets/UI2/kefu_icon.png')" />
    </div>
    <!-- 购物车 -->
    <!-- <div class="cart_bottom">
      <div class="cart_bottom_icon" @click="toCartPath">
        <van-image width="1.6rem" height="1.6rem"
                   src="https://hxxxkj-oss-cdn.xiaoyi120.com/wholesale-H5/cart_icon.png"
        />
        <div v-if="$store.getters.totalShopping > 0" class="badge_box">{{ $store.getters.totalShopping }}</div>
      </div>
      <div class="cart_bottom_info flex-r-c-c">
        <div class="info_total">
          <span style="font-size: 0.32rem;color: #333;font-weight: 400;">合计：</span>
          <span style="font-size: 0.32rem;">￥</span><span>{{ $store.getters.totalShoppingMoney }}</span>
        </div>
        <div class="info_button" @click="toCartPath">去购物车</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import './index.scss'
import Tabber from '@/components/tabber'
import kefuBtn from '@/components/kefu_btn'
import { user_certificationDecide } from '@/api/user'
import { mallProduct_hotSearch, apiWholesaleSaleModule_imageList, apiWholesaleProduct_productRecommendList, apiWholesaleProduct_productList } from '@/api/pro'
import { shoppingCart_addUnion } from '@/api/cart'
import { apiWholesaleAgent_list } from '@/api/agency'
import ser_top_filter_right from '@/components/ser_top_filter_right'
import MyscrollList from '@/components/MyscrollList'
export default {
  name: 'Index',
  components: { Tabber, ser_top_filter_right, MyscrollList, kefuBtn },
  data() {
    return {
      certificationShow: false, // 资质认证
      searchValue: '',
      info: {}, // discount
      hotList: [],
      banners: [],
      specilActive: [],
      agencyBrandList: [],
      searchForm: { page: 1, limit: 18, name: '' },
      proList: [],
      streamerList: [],
      tabberList: [],
      notice: [],

      // 首次广告
      adsDialog: false,
      adsItem: []

    }
  },
  created() {
    this.$utils.cartNum(this.$store)
    this.getCertificationDecide()
    this.loadItem()
    this.loadHot()
    this.getRecommendList()
    this.loadAgencyList()
  },
  onShow() {
    this.$utils.cartNum(this.$store)
  },
  methods: {
    openKeFu() { this.$refs.mykefuBtn.changeShow(true) },
    // 用户进入首页判断是否有资质
    getCertificationDecide() {
      user_certificationDecide().then(res => {
        this.certificationShow = res.data.wholesaleCertificationType !== 1
      })
    },
    // 加载代理品牌列表
    loadAgencyList() {
      apiWholesaleAgent_list({ page: 1, limit: 99 }).then(res => {
        var index2 = 0; var count2 = 4; var arrTemp2 = []; var experts2 = res.data.list
        for (var i = 0; i < res.data.list.length; i++) {
          index2 = parseInt(i / count2)
          if (arrTemp2.length <= index2) { arrTemp2.push([]) }
          arrTemp2[index2].push(experts2[i])
        }
        this.agencyBrandList = arrTemp2
        console.log('agencyBrandList', this.agencyBrandList)
      })
    },
    // 加载热门搜索
    loadHot() { mallProduct_hotSearch().then(res => { this.hotList = res.data }) },
    // 模块加载
    loadItem() {
      // 首页banner
      apiWholesaleSaleModule_imageList({ pageNum: 1, pageSize: 999, mallSaleModuleId: '1583032697968791552' }).then(res => { this.banners = res.data.list })
      // 横幅
      // apiWholesaleSaleModule_imageList({ pageNum: 1, pageSize: 10, mallSaleModuleId: '1828689445650567168' }).then(res => { this.streamerList = res.data.list })
      // 底部tabber
      // apiWholesaleSaleModule_imageList({ pageNum: 1, pageSize: 10, mallSaleModuleId: '1828667982549749760' }).then(res => { this.tabberList = res.data.list })
      // 公告
      apiWholesaleSaleModule_imageList({ pageNum: 1, pageSize: 10, mallSaleModuleId: '1830859408855404544' }).then(res => { this.notice = res.data.list })
      // 广告营销
      apiWholesaleSaleModule_imageList({ pageNum: 1, pageSize: 10, mallSaleModuleId: '2000443196865384448' }).then(res => {
        this.adsItem = res.data.list
        this.adsDialog = res.data.list.length > 0
      })
    },
    // 营销模块的跳转事件
    jumpSale(type, item) {
      console.log(item.imageValue.substring(0, 1))
      // if (type === 'banner') { this.$router.push(item.imageValue) }
      // if (type === 'streamer') {
      //   this.$router.push(item.imageValue)
      //   if (item.imageValue.substring(0, 1) === '/') {
      //     this.$router.push(item.imageValue)
      //   } else {
      //     this.$router.push('/product/proList?id=' + item.imageValue + '&title=' + item.name)
      //   }
      // }
      if (item.imageType === 1) {
        if (item.imageValue !== '0') { window.open(item.imageValue) }
      }
      if (item.imageType === 2) {
        sessionStorage.setItem('listJump', true)
        this.$router.push('/product/proList?id=' + item.imageValue + '&title=' + item.name)
      }
      if (item.imageType === 3) { this.$router.push('/product/detail?productId=' + item.imageValue) }
      // if (item.imageType === 4) {
      //   sessionStorage.setItem('listJump', true)
      //   this.$router.push('/product/brandList?name=' + item.imageValue) // 品牌精选
      // }
      if (item.imageType === 5) {
        this.$router.push(item.imageValue)
      }
    },
    // 推荐管理区域商品列表
    getRecommendList() {
      // 特惠活动
      apiWholesaleProduct_productRecommendList({ page: 1, limit: 20, tagId: '331' }).then(res => {
        // 4
        var index2 = 0; var count2 = 4; var arrTemp2 = []; var experts2 = res.data.list
        for (var i = 0; i < res.data.list.length; i++) {
          index2 = parseInt(i / count2)
          if (arrTemp2.length <= index2) { arrTemp2.push([]) }
          arrTemp2[index2].push(experts2[i])
        }
        this.specilActive = arrTemp2
        console.log('specilActive', this.specilActive)
      })
      this.getProList()
    },
    // 加购物车
    toCart(item) {
      const parms = { productId: item.productId, priceNum: item.minQuantity }
      console.log(parms)
      shoppingCart_addUnion(parms).then(res => {
        this.$toast({ message: '加入成功！', duration: 1 * 1000 })
        this.$utils.cartNum(this.$store)
      })
    },
    // 活动 banner 跳转事件
    jumpUrl(url) { window.open(url) },
    jumpTagList() { this.$router.push('/product/tagProList') },
    // 去认证
    toUpCertification() { this.$router.push('/home/certification') },
    // 进入商品列表 1热品 2特惠
    jumpList(type) { this.$router.push('/product/proBannerList?type=' + type) },
    jumpjianlou(item) { this.$router.push('/product/detail?productId=' + item.productId) },
    toAllPro() { this.$router.push('/product/allPro') },

    // 顶部搜索
    changeFilter(e) {
      console.log(e)
      this.searchForm.page = 1
      if (e === 1 || e === 41) {
        this.searchForm.orderType = ''
        this.searchForm.orderWay = ''
        this.searchForm.tagId = ''; this.searchForm.proBrand = ''; this.searchForm.categoryId = ''
      }
      if (e === 2) {
        this.issaleNum = !this.issaleNum
        this.searchForm.orderType = 'SALE_NUM'
        this.searchForm.orderWay = this.issaleNum ? 'DESC' : 'ASC'
        this.searchForm.tagId = ''; this.searchForm.proBrand = ''; this.searchForm.categoryId = ''
      }
      if (e === 3) {
        this.isprice = !this.isprice
        this.searchForm.orderType = 'PRICE'
        this.searchForm.orderWay = this.isprice ? 'DESC' : 'ASC'
        this.searchForm.tagId = ''; this.searchForm.proBrand = ''; this.searchForm.categoryId = ''
      }
      if (e === 42) {
        this.searchForm.orderType = ''; this.searchForm.orderWay = ''; this.searchForm.proBrand = ''; this.searchForm.categoryId = ''
        this.searchForm.tagId = '282'
      }
      if (e === 43) {
        this.searchForm.orderType = ''; this.searchForm.orderWay = ''; this.searchForm.proBrand = ''; this.searchForm.categoryId = ''
        this.searchForm.tagId = '281'
      }
      if (e === 44) {
        this.searchForm.orderType = ''; this.searchForm.orderWay = ''; this.searchForm.proBrand = ''; this.searchForm.categoryId = ''
        this.searchForm.tagId = '275'
      }
      this.proList = []
      this.getProList()
    },
    changeFiltercategory(id) {
      this.searchForm.page = 1
      this.searchForm.orderType = ''; this.searchForm.orderWay = ''; this.searchForm.proBrand = ''
      this.searchForm.tagId = ''; this.searchForm.categoryId = id
      this.$nextTick(() => {
        this.proList = []
        this.getProList()
      })
    },
    // 查询事件
    getProList() {
      this.$toast.loading({ message: '加载中...', forbidClick: true, loadingType: 'spinner', duration: 0 })
      apiWholesaleProduct_productList(this.searchForm).then(res => {
        this.$toast.clear()
        this.$refs.myList01.load_loading(false)
        this.proList = this.proList.concat(res.data.list)
        // 存localstrong
        if (this.searchForm.page === 1 && res.data.list.length === 0) {
          this.$refs.myList01.load_empty('ser', true)
        } else {
          if (res.data.list.length < 10) { // 数据全部加载完成
            if (res.data.list.length > 0) {
              this.$refs.myList01.load_finished(true)
            }
          }
        }
      })
    },
    proload() {
      this.$refs.myList01.load_loading(true)
      this.$utils.debounce(() => {
        this.searchForm.page = this.searchForm.page + 1
        this.getProList(1)
        // 加载状态结束
      }, 50)()
    },
    jumpAgency(item) {
      if (item) {
        this.$router.push('/agency/agency?wholesaleAgentBrandId=' + item.wholesaleAgentBrandId)
      } else {
        this.$router.push('/agency/agency')
      }
    },
    Closeadvs() {
      var video = document.getElementById('myVideo')
      console.log('video', video)
      video.play()
      // video.pause()
      this.adsDialog = false
    }

  }
}
</script>
